// extracted by mini-css-extract-plugin
module.exports = {"sticky":"Sticky__sticky___1diu9"};